const header = {
  header: {
    logOut: 'Cerrar sesión',
    enphaseStore: 'Tienda de Enphase',
    enphaseSupport: 'Soporte técnico de Enphase ',
    comingSoon: 'Próximamente',
    new: 'Nuevo'
  }
};

export default header;
